import { AppConfig } from './../../../AppConfig';
import { Auth } from './../../../autentication/Auth';
import { Sms } from './../model/sms';
import { ChangeDigitalSignatureEventType } from './../change-digital-signature.event.type';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, Directive, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ChangeDigitalSignatureService } from '../change-digital-signature.service';
import { EventTypes } from '../../../shared/EventTypes';

@Component({
	selector: 'app-sms-validation-signature',
	templateUrl: './sms-validation-signature.component.html',
	styleUrls: ['./sms-validation-signature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SmsValidationComponent implements OnInit, OnDestroy {

	view = '[data-component="sms-validation-signature"]';
	active = false;
	sms: Sms;
	activeInput: any;
	activeInputIndex = 0;
	smsCode = '';
	loading = false;
	sendCodeLoading = false;
	validationError = false;
	canSend = false;
	smsTry = 1;
	disabled = false;

	constructor(private changeDigitalSignatureEventType: ChangeDigitalSignatureService) {

	}

	ngOnInit() {

		AppEventDispatcher.listen(ChangeDigitalSignatureEventType.LOGIN.SMS_VALIDATION, data => {
			if (data.show) {
				this.active = true;
				this.sms = data.sms;

				const interval = setInterval(() => {
					if ($(this.view).length > 0) {
						this.show(data);
						clearInterval(interval);
					}
				}, 10);

			}
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangeDigitalSignatureEventType.LOGIN.SMS_VALIDATION);
	}

	show(data) {

		this.smsTry = AppConfig.smsTry;

		/* $('#smsCode').pincodeInput({inputs: this.sms.size, hidedigits: false,
		complete: (value, e, errorElement) => {
			this.pinComplete();
		}}); */

		this.activeInput = $('.pincode-input-text.first');

		$('.pincode-input-text').keydown( () => {

			return false;

		});

		TweenMax.to(this.view, .8, {delay: data.delay, left: 0, ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to(this.view, .8, {left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	pinComplete() {
		// alert(' PIN COMPLETE');
	}

	getKeyboardValue(value) {

		if (this.activeInputIndex <= (this.sms.size - 1)) {
			this.activeInput.val(value[0]);
			this.activeInputIndex++;
			this.activeInput = $($('.pincode-input-text')[this.activeInputIndex]);
			this.activeInput.focus();

			if (this.activeInputIndex > (this.sms.size - 1)) {
				this.canSend = true;
			}
		}
	}

	clearInputs() {
		$('.pincode-input-text').val('');
		$('.pincode-input-text.first').focus();
		this.activeInputIndex = 0;
		this.activeInput = $('.pincode-input-text.first');
		this.canSend = false;
	}

	send() {

		this.preload(true);

		if (this.canSend) {
			this.smsCode = '';
			const self = this;
			this.disabled = true;
			$('.pincode-input-text').each(function() {
				self.smsCode += $(this).val();
			});

			if (!this.loading && (this.smsCode.length === this.sms.size)) {
				this.loading = true;
				this.validationError = false;
				Auth.codigoSms = this.smsCode;
				this.changeDigitalSignatureEventType.sendSmsCode(Auth.getInstance().getUser().cpf, this.smsCode).subscribe( data => {

					this.canSend = false;
					this.loading = false;
					this.hide();
					this.disabled = false;
					this.preload(false);
					AppEventDispatcher.dispatch(ChangeDigitalSignatureEventType.STEPS.CHANGE_DG_SIGNATURE_RESET, { show: true });

				}, error => {

					this.preload(false);
					this.loading = false;
					this.disabled = false;
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });

				});
			} else if (this.smsCode.length !== this.sms.size) {
				this.validationError = true;
				this.disabled = false;
				this.preload(false);
			}
		}

	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="reset"] .content', show: active, delay: delay });
	}

	sendCodeAgain() {
		if (!this.sendCodeLoading) {
			this.clearInputs();
			this.validationError = false;
			this.sendCodeLoading = true;
			this.changeDigitalSignatureEventType.getSmsCode(Auth.getInstance().getUser().cpf).subscribe( sms => {
				this.sendCodeLoading = false;
			});
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-digital-signature/sms-validation-signature/sms-validation-signature.component.ts